<template>
  <form 
    class="animated fadeIn" 
    @submit.prevent="login()">
    <h1>Login</h1>
    <p class="text-muted">Sign In to your account</p>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="icon-user"/></span>
      </div>
      <input 
        v-model="user.username" 
        type="email" 
        class="form-control" 
        placeholder="Username" 
        required>
    </div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="icon-lock"/></span>
      </div>
      <input 
        v-model="user.password" 
        type="password" 
        class="form-control" 
        placeholder="Password" 
        required>
    </div>
    <div 
      v-show="loginFailed" 
      class="row mb-3">
      <div class="col">
        <small class="text-danger">{{ errorMsg }}</small>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <button 
          :disabled="isFetching" 
          type="submit" 
          class="btn btn-primary btn-block">
          Login&nbsp;
          <i 
            v-show="isFetching" 
            class="fa fa-spinner fa-spin"/>
        </button>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-6">
        <router-link 
          :to="{name: 'Registration', query: urlQuery}" 
          class="px-0">Register</router-link>
      </div>
      <div class="col-6 text-right">
        <router-link 
          :to="{name: 'Forgot Password', query: urlQuery}" 
          class="px-0">Forgot Password</router-link>
      </div>
    </div>
  </form>
</template>
<script>
import auth from '@/services/auth.service'

export default {
  name: 'Login',
  data () {
    return {
      user: Object,
      errorMsg: String,
      isFetching: false,
      loginFailed: false
    }
  },
  computed: {
    urlQuery () {
      let params = this.$route.query
      return params
    }
  },
  methods: {
    login() {
      this.isFetching = true
      this.loginFailed = false
      let appId = this.$route.query.appId
      auth.login(this.user, appId)
        .then((resp) => {
          if (process.env.VUE_APP_MODE === 'local') { // redirect into localhost:8081
            window.location.href = `${process.env.VUE_APP_REDIRECT_URL}?hash=${resp.token}&user=${this.user.username}`
          } else {
            if (resp.changePassLink) {
              this.$router.push({path: '/change-password', query: {changeInitRegPass: 1, hash: resp.token, appId: appId}})
              return false
            } else {
              window.location.href = `${resp.serviceUrl}?hash=${resp.token}&user=${this.user.username}`
            }
          }

        }, (err) => {
          this.isFetching = false
          this.loginFailed = true
          this.errorMsg = err.data.msgContent
        })
    }
  },
}
</script>
